import createReducer from "Common/reducerUtils/createReducer";
import { NAMESPACE } from "../constants";
import set from "lodash/set";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {}
};
export default createReducer(initialState, {
    [actionTypes.SAVE_FILE_COMPLETE]: (state, { payload }) => set(state, `[${NAMESPACE}].lastSaveFileUrl`, payload),
    [actionTypes.API_VOICE_RECOGNITION_COMPLETE]: (state, { payload }) => set(state, `[${NAMESPACE}].voiceRecognition`, payload)
});
